import "./game_over_screen.css";
import ExitButton from "../../components/exitbutton/exitbutton";
import { config } from "../../config";
// import ExitButton from '../components/exit_button';

function GameOverScreen({ points, restartGame }) {
  return (
    <div className="game-over-container">
      <ExitButton />
      <div className="game-over-screen" id="game-over-screen">
        {points >= config.coinMultiplier * 4 ? (
          <div className="congratulations">Congratulations</div>
        ) : null}
        <div className="you-win">You won</div>
        <div className="zu-coins">{points} Points</div>
        {points >= 4 * config.coinMultiplier ? (
          <div
            className="next-task"
            onClick={() => {
              window.navigation_handler.postMessage("navigate=exit");
            }}
          >
            Next Task
          </div>
        ) : null}
        <div
          className="next-task"
          onClick={() => {
            document
              .getElementById("game-over-screen")
              .classList.add("fade-out");
            setTimeout(() => {
              restartGame();
            }, 1000);
          }}
        >
          Play Again
        </div>
      </div>
    </div>
  );
}

export default GameOverScreen;
